import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ShimmerCategoryItem } from "react-shimmer-effects";
import NoContentFound from "../../../default/not-found/notFound";
import { GetAllSubscription } from "../../../../store/actions/new/subscriptionListAction";
import { Link } from "react-router-dom";
import { GetServiceData } from "../../../../store/actions/new/storeAction";
const MyPlanData = () => {
    const [openDropdown, setOpenDropdown] = useState(null);
    const toggleDropdown = (index) => {
        setOpenDropdown(prevIndex => (prevIndex === index ? null : index));
    };
    const handleOutsideClick = (event) => {
        if (!event.target.closest('.list-edit-dropdown') &&
            !event.target.closest('.dropdown-toggle-btn')) {
            setOpenDropdown(null);
        }
    };
    useEffect(() => {
        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, []);

    // store data
    const { subscriptionData, storeData } = useSelector((store) => store);
    const { data, isLoading } = subscriptionData;
    const { services } = storeData;
    const { data: servicesData, isLoading: serviceLoading } = services;
    const dispatch = useDispatch();

    useEffect(() => {
        if (!data || data.length === 0) {
            dispatch(GetAllSubscription());
        }
        if (!servicesData || servicesData.length === 0) {
            dispatch(GetServiceData());
        }
    }, [dispatch, data])

    return (
        <div className="card-container card-list-area">
            <div className="list-table connection-list">
                {!isLoading && data &&
                    <table>
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th>Card limit</th>
                                <th>Lead</th>
                                <th>Renewal date</th>
                                <th  align='right'>Price</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.length > 0 && data.map((item, index) => {
                                return (
                                    <tr>
                                        <td>
                                            <div className="list-profile">
                                                <span>{item.productTitle}</span>
                                            </div>
                                        </td>
                                        <td>{item.cardLimit}</td>
                                        <td>{item.leadLimit}</td>
                                        <td>{item.dateTo.split(' ')[0]} {item.autoRenewal === "0" ? <span className='table-badge bg-red'>Not renewing</span> : ""}</td>
                                       <td  align='right'>${item.price} <span className='table-badge'>{item.productRenewalIntervalUnit === "months" ? "Monthly" : "Yearly"}</span></td>
                                        <td align='right'>
                                            <button
                                                className="share-button icon-button list-btn dropdown-toggle-btn"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    toggleDropdown(index);
                                                }}
                                            >
                                                <i
                                                    className="ri-more-2-fill"
                                                ></i>
                                            </button>
                                            <div className="list-edit-dropdown">
                                                {openDropdown === index && (
                                                    <ul>
                                                        <li><a href='#'>Support</a></li>
                                                    </ul>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })}

                        </tbody>
                    </table>
                }
                {isLoading &&
                    <>
                        <ShimmerCategoryItem
                            hasImage
                            imageType="circular"
                            imageWidth={50}
                            imageHeight={50}
                            text
                        />
                        <ShimmerCategoryItem
                            hasImage
                            imageType="circular"
                            imageWidth={50}
                            imageHeight={50}
                            text
                        />
                    </>
                }

                {(!data || data.length === 0) && !isLoading && (
                    <div className="no-packages">
                        <NoContentFound title="Data not found!" />
                    </div>
                )}
            </div>
            <div className="connection-header inside-header">
                <h3>Services</h3>
                <div className="filter-wrapper">
                    <Link className="list-filter add-new-btn" to="/user/store/services">
                        <i className="ri-add-line"></i><span>Add New</span>
                    </Link>
                </div>
            </div>
            <div className="list-table connection-list">
                {!serviceLoading && servicesData &&
                    <table>
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th>Description</th>
                                <th>Price</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            {servicesData.length > 0 && servicesData.map((item, index) => {
                                return (
                                    <tr>
                                        <td>
                                            <div className="list-profile">
                                                <span>{item.title}</span>
                                            </div>
                                        </td>
                                        <td>{item.description}</td>
                                        <td>${item.price}</td>
                                        <td align='right'>
                                            <button
                                                className="share-button icon-button list-btn dropdown-toggle-btn"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    toggleDropdown(index + "ser");
                                                }}
                                            >
                                                <i
                                                    className="ri-more-2-fill"
                                                ></i>
                                            </button>
                                            <div className="list-edit-dropdown">
                                                {openDropdown === (index + "ser") && (
                                                    <ul>
                                                        <li><a href='#'>Support</a></li>
                                                    </ul>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                )
                            })}

                        </tbody>
                    </table>
                }
                {isLoading &&
                    <>
                        <ShimmerCategoryItem
                            hasImage
                            imageType="circular"
                            imageWidth={50}
                            imageHeight={50}
                            text
                        />
                        <ShimmerCategoryItem
                            hasImage
                            imageType="circular"
                            imageWidth={50}
                            imageHeight={50}
                            text
                        />
                    </>
                }

                {(!data || data.length === 0) && !isLoading && (
                    <div className="no-packages">
                        <NoContentFound title="Data not found!" />
                    </div>
                )}
            </div>
        </div>

    );
}

export default MyPlanData;